import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'flex flex-col bg-[linear-gradient(145deg,var(--white-alpha-95),var(--surface-project-card-end))] border ' +
            'border-(--control-border-neumorphic) transition-[filter,transform,border-color] duration-300 ' +
            'ease-[cubic-bezier(0.25,0.8,0.25,1)] rounded-3xl will-change-[transform,filter,border-color] group ' +
            'relative overflow-hidden p-2',
        imageWrapper: 'relative mb-2 h-80 w-full shrink-0 overflow-hidden rounded-2xl shadow-inner',
        image: 'w-full h-full object-cover',
        imageOverlay: 'absolute inset-0 bg-linear-to-t from-gray-900/50 to-transparent pointer-events-none',
        location: 'absolute top-3 left-3',
        status: 'absolute top-3 right-3',
        content: 'flex flex-1 flex-col px-2',
        titleRow: 'flex justify-between items-start mb-1',
        title: 'text-xl font-bold text-gray-800 leading-tight',
        metrics:
            'grid flex-1 grid-cols-2 gap-x-4 gap-y-2 rounded-xl border border-(--white-alpha-40) ' +
            'bg-[rgba(236,241,247,0.4)] p-3 text-sm text-(--text-soft) ' +
            'shadow-[inset_2px_2px_6px_rgba(163,177,198,0.2),inset_-2px_-2px_6px_rgba(255,255,255,0.6)]',
        metric: 'flex flex-col',
        metricLabel: 'mb-1 text-[0.625rem] font-bold uppercase tracking-wider text-gray-400',
        metricValue: 'font-medium text-gray-700',
        classIndicator: 'h-1.5 w-1.5 rounded-full bg-indigo-500',
        footer: 'mt-auto pt-2 px-2 flex gap-2 items-center border-t border-gray-100 text-(--text-soft)',
        assistantButton: 'text-violet-500 hover:text-violet-600',
        deleteButton: 'text-rose-500 hover:text-rose-600'
    },
    variants: {
        right: {
            true: {
                metric: 'text-right'
            }
        },
        isClass: {
            true: {
                metricValue: 'flex items-center gap-1'
            }
        }
    },
    compoundVariants: [
        {
            right: true,
            isClass: true,
            class: {
                metricValue: 'justify-end'
            }
        }
    ]
} satisfies ComponentTheme;
